import { call, fork, put, takeLatest } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/geo";
import { GET_CITIES_REQUEST, GET_DISTRICTS_REQUEST } from "../types";

function* watchGetCities() {
  yield takeLatest(GET_CITIES_REQUEST, getCities);
}
function* watchGetDistricts() {
  yield takeLatest(GET_DISTRICTS_REQUEST, getDistricts);
}

function* getCities(action) {
  try {
    const res = yield call(apiGetCities);
    const items = res.data.reduce((acc, value) => {
      acc.push({
        value: value.id,
        name: value.name,
      });
      return acc;
    }, []);

    yield put(
      actions.getCitiesSucceeded(
        items.sort(function (a, b) {
          return a.value - b.value;
        })
      )
    );
  } catch (err) {
    yield put(actions.getCitiesFailed());
  }
}

function* getDistricts(action) {
  try {
    const res = yield call(apiGetDistricts, {
      ...action.payload,
    });

    const items = res.data.reduce((acc, value) => {
      acc.push({
        value: value.name,
        name: value.name,
      });
      return acc;
    }, []);

    yield put(
      actions.getDistrictsSucceeded(
        items.sort(function (a, b) {
          return a.value - b.value;
        })
      )
    );
  } catch (err) {
    yield put(actions.getDistrictsFailed());
  }
}

const apiGetCities = () => API_GET("cities", {});
function apiGetDistricts(reqParams) {
  return API_GET("districts", {
    cityId: reqParams.cityId,
  });
}

export default function* geoSaga() {
  yield fork(watchGetCities);
  yield fork(watchGetDistricts);
}
